<template>
  <div id="app" class="flex min-h-screen relative">
    <vue-progress-bar></vue-progress-bar>
    <div class="flex-none min-h-screen bg-grey-darker w-64 pt-24 px-6 text-white relative">
      <div class="absolute pin-t pin-l pin-r flex bg-grey-darkest px-6 w-64 h-16 flex items-center text-white uppercase">
        Bellman
        <span class="text-blue-lighter ml-1">Catering</span>
      </div>
      <Sidebar />
    </div>
    <div class="w-full">
      <Top />
      <div class="px-10 py-8 mx-auto">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/service/api.service";
export default {
  components: {
    Sidebar: () =>
      import(/* webpackChunkName: "global-sidebar" */ "@/views/Common/Sidebar"),
    Top: () => import(/* webpackChunkName: "global-top" */ "@/views/Common/Top")
  },
  mounted() {
    ApiService.get(process.env.VUE_APP_API_URL + `auth/user/`).then(
      ({ data }) => {
        this.$store.commit("User/info", data.data);
      }
    );
  }
};
</script>
